export default "__VITE_ASSET__d0d4965f__"